export default [
    {
        name: '猫砂余量',
        key: 'Sand'
    },{
        name: '集便盆空间',
        key: 'room_of_bin',
        caption: ['充足', '已满', '不在位']
    },{
        name: '童锁功能',
        key: 'childLockOnOff',
        caption: ['关闭', '打开']
    },{
        name: '勿扰模式',
        key: 'DND_Mode'
    },{
        name: '清理设置',
        key: 'cleanCfg'
    },{
        name: '砂仓状态',
        key: 'bucketStatus',
        caption: ['空闲中', '归位中', '清理中', '抚平中', '倒砂中', '占用中', '暂停中', '故障中', '关机中', '猫咪出没', '称重修复中', '仓满归位中']
    },{
        name: '打断范围检测',
        key: 'bIntrptRangeDet',
        caption: ['全范围', '危险范围']
    },{
        name: '幼猫模式',
        key: 'youngCatMode',
        caption: ['关闭', '开启']
    },{
        name: '静音模式',
        key: 'silentMode',
        caption: ['关', '开']
    },{
        name: '网络状态',
        key: 'NetWorkStatus'
    },{
        name: 'SN码',
        key: 'SN_Code'
    },{
        name: '时区信息',
        key: 'timeZoneMsg'
    },{
        name: '机器版本',
        key: 'DeviceVer'
    },{
        name: '电机监测',
        key: 'motorMonitor'
    },{
        name: '自动掩埋',
        key: 'autoBury',
        caption: ['关闭', '开启']
    },{
        name: '清理记录',
        key: 'cleanRecord'
    },{
        name: '今日记录',
        key: 'todayRecord'
    },{
        name: '设备所在的区域',
        key: 'region'
    },{
        name: '用户的阿里openId',
        key: 'userOpenId'
    },{
        name: 'APP版本',
        key: 'appVersion'
    },{
        name: '重量校准',
        key: 'scaleCalibrate'
    },{
        name: '最后加砂时间',
        key: 'latestAddSandTime'
    },{
        name: '自动清理跟踪',
        key: 'cleanTrace'
    },{
        name: '系统状态',
        key: 'systemStatus'
    },{
        name: '错误记录',
        key: 'errorRec'
    },{
        name: '连接状态',
        key: 'connStatus'
    },{
        name: 'debug开关',
        key: 'debugSW',
        caption: ['关闭', '开启']
    },{
        name: '蜂鸣器',
        key: 'beep',
        caption: ['', '短鸣']
    },{
        name: '重量打印开关',
        key: 'weightPrSW',
        caption: ['关闭', '开启']
    },{
        name: '服务器环境',
        key: 'GenHighSvcEnv',
        caption: ['正式环境', '测试环境']
    },{
        name: 'GoogleHome测试字段',
        key: 'testValue'
    },{
        name: '仓满待解除',
        key: 'binFullWaitReset',
        caption: ['无', '待解除']
    },{
        name: '按键动作',
        key: 'keyAction'
    },{
        name: '机器启动',
        key: 'Reboot'
    },{
        name: '称重标定数据',
        key: 'weightCalibraData'
    },{
        name: '称重数据',
        key: 'weightData'
    },{
        name: '断线原因',
        key: 'disconn'
    },{
        name: '队列长度',
        key: 'queueLen'
    },{
        name: '设备动作',
        key: 'devAction'
    },{
        name: '区域地址',
        key: 'baseURL'
    },{
        name: '猫咪离开',
        key: 'catLeft'
    },{
        name: '12小时开关',
        key: 'is12HourFormat',
        caption: ['关', '开']
    },{
        name: '自动抚平',
        key: 'autoLevel',
        caption: ['关', '开']
    },{
        name: '最后废物箱清洗时间',
        key: 'lastWasteWashTime'
    },{
        name: '最后废物箱清空时间',
        key: 'lastWasteCleanTime'
    },{
        name: '后端下发的设备区域服地址',
        key: 'regionBaseurl'
    },{
        name: '后端下发的时间戳',
        key: 'timestamp'
    },{
        name: '设备网络信息缓存',
        key: 'netMsgCache'
    },{
        name: '砂仓超时记录',
        key: 'bucketTimeout'
    },{
        name: '错误屏蔽',
        key: 'errBanBits'
    },{
        name: '仓满归位开关',
        key: 'autoForceInit',
        caption: ['关', '开']
    }
]


// WEBPACK FOOTER //
// ./src/js/catBoxRunStateConfig.js